// extracted by mini-css-extract-plugin
export default {"main":"Search_main__YLCL4","divider":"Search_divider__7WM2e"};